import { render, staticRenderFns } from "./TextboxQuestionOptions.vue?vue&type=template&id=33b77a65&scoped=true&"
import script from "./TextboxQuestionOptions.vue?vue&type=script&lang=js&"
export * from "./TextboxQuestionOptions.vue?vue&type=script&lang=js&"
import style0 from "./TextboxQuestionOptions.vue?vue&type=style&index=0&id=33b77a65&prod&scoped=true&lang=css&"
import style1 from "./TextboxQuestionOptions.vue?vue&type=style&index=1&id=33b77a65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b77a65",
  null
  
)

export default component.exports